import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

import { buildUrlWithoutParam } from '$src/utils';

const USER_ID_KEY = 'just_uuid';

export const useUserId = () => {
  const router = useRouter();
  const hasCheckUid = useRef(false);

  useEffect(() => {
    if (hasCheckUid.current) return;
    hasCheckUid.current = true;

    try {
      if (router.query?.uid && typeof router.query.uid === 'string') {
        const uid = router.query.uid;

        // Build new URL without uid parameter
        const newUrl = buildUrlWithoutParam(router.pathname, router.query, 'uid');
        router.replace(newUrl, undefined, { shallow: true });

        // Store uid in localStorage
        window.localStorage.setItem(USER_ID_KEY, uid);
      }
    } catch (error) {
      console.error('[APP] Failed to retrieve user id:', error);
    }
  }, [router?.query?.uid, router?.pathname]);

  return null;
};
